/*global Cookies */
/*eslint no-unused-vars: 0*/

(function ($, _) {
    "use strict";

    var hide_sitewide_alert = Cookies.get('hide-site-wide-alert-container'),
        $alert_template_container = $("#alert_container"),
        alert_template = _.template($("#sitewide_alert_template").html());

    if (hide_sitewide_alert) {
        return false;
    }

    $(document).ready(function () {

        var alert_url = window.alert_blog_url,
            site_id = window.alert_blog_current,
            site_id_list;

        if (!alert_url) return false;

        // Use local proxy endpoint instead of cross-origin request
        // This eliminates CORS issues by making same-origin requests
        alert_url = '/wp-json/wp/v2/mat_alert'

        // Get target language translation parameter from the Google Translate url.
        var target_language = (location.search.split('langpair=')[1] || '').split('&')[0].split('%7C')[1];
        if (typeof(target_language) === "undefined" || target_language === ""){
            target_language = (location.search.split('tl=')[1] || '').split('&')[0];
        }
        if (typeof(target_language) === "undefined" || target_language === ""){
            target_language = "en";
        }

        // Pass the target language in the header, where translations are made on the backend.
        $.ajax({
            type: 'GET',
            url: alert_url,
            async: false,
            contentType: "application/json",
            dataType: 'json',
            headers: {
                "content-language": target_language
            },
            success: function(data) {

                if (data.length < 1) return;

                site_id_list = (data[0].post_meta.site_id_list) ? data[0].post_meta.site_id_list : [];

                if (site_id_list.includes(String(site_id))) {
                    $alert_template_container.html(alert_template({
                        'data': data[0].post_meta,
                        'response': data[0]
                    }));

                    $('#alert_dismissal_button').on('click', function (event) {
                        event.preventDefault();
                        $alert_template_container.html("");
                        Cookies.set('hide-site-wide-alert-container', true, {expires: 1});
                    });
                }
            },
            error: function(e) {
                console.log(e);
            }
        });
    });

})(jQuery, _);
